/**
 * Где в заголовке кончается первый цвет.
 *
 * Наз про правило деления сказала «красят по смыслу», и на живом посте Alash
 * видно, что именно это значит: «РЕФОРМАНЫ ЕКІНІҢ БІРІ ЖАСАЙ АЛМАЙДЫ» бирюзой,
 * дальше двоеточие и белым «КӘСІПКЕР ТОҚАЕВТЫҢ...». Граница проходит ПОСРЕДИ
 * строки, а не по её концу — красится смысловой кусок, а не первая строка.
 *
 * Правило:
 *   1. Явный перенос строки, если редактор его поставил, — он главнее всего.
 *   2. Иначе первое смысловое двоеточие; сам знак красится вместе с первой
 *      частью — так в макете.
 *   3. Нет ни того, ни другого — не делим вообще.
 *
 * Смысловое — значит не время и не счёт. Двоеточие с цифрами по обе стороны
 * («В 18:30 НАЧНЁТСЯ КОНЦЕРТ», «СЧЁТ 2:1 В ПОЛЬЗУ КАЗАХСТАНА») границей не
 * считается: раньше такое красило «В 18» и «СЧЁТ 2», а в новостном заголовке
 * время и счёт — обычное дело. Пропустив его, ищем следующее: в «В 18:30
 * ТОҚАЕВ: РЕФОРМА» делит второе двоеточие, а не первое.
 *
 * Условие именно на цифры по обе стороны, а не на пробел после знака. Иначе
 * «ТОҚАЕВ:РЕФОРМА», написанное без пробела, перестало бы делиться, хотя
 * сегодня делится верно.
 *
 * Пункт 3 — сознательный отказ от прежнего «красим первую строку». Та строка
 * обрывалась там, где случайно лёг перенос: у Alash выходило бирюзовое
 * «Токаев за» и белое продолжение с середины фразы. Обрыв по случайному месту
 * не бывает осмысленным, поэтому лучше один цвет, чем деление наугад.
 */
const isDigit = (ch: string | undefined): boolean => ch !== undefined && ch >= '0' && ch <= '9';

export function resolveColorBoundary(text: string): number | null {
  const nl = text.search(/\r?\n/);
  if (nl >= 0) return nl;

  // С единицы: двоеточие в самом начале делить нечего.
  for (let i = 1; i < text.length; i++) {
    if (text[i] !== ':') continue;
    if (isDigit(text[i - 1]) && isDigit(text[i + 1])) continue;
    // +1: двоеточие входит в первую, крашеную часть.
    return i + 1;
  }
  return null;
}
